import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import {
  fetchDevelopersProfileFail,
  fetchDevelopersProfileSuccess,
} from "./action";

import { FETCH_DEVELOPERS_PROFILE } from "./actionType";

import axios from "axios";
import common from "../../Components/Common/common";

const fetchDevelopersProfileAPI = async (payload) => {
  try {
    let response = await axios.post(
      `/developer-profile/get-developer-profile`,
      payload || { page: 1, limit: 1000 }
    );

    let result = response?.data !== undefined ? response.data : response;
    if (typeof result === "string") {
      const decrypted = common.decrypt(result);
      if (decrypted) result = decrypted;
    } else if (result && typeof result.data === "string") {
      const decrypted = common.decrypt(result.data);
      if (decrypted) result = decrypted;
    }

    return result;
  } catch (error) {
    throw error;
  }
};

function* getDevelopersProfile(action) {
  try {
    const payload = action?.payload || { page: 1, limit: 1000 };
    const response = yield call(fetchDevelopersProfileAPI, payload);
    yield put(fetchDevelopersProfileSuccess(response));
  } catch (error) {
    yield put(fetchDevelopersProfileFail(error.response || error));
  }
}

export function* watchGetDevelopersProfile() {
  yield takeEvery(FETCH_DEVELOPERS_PROFILE, getDevelopersProfile);
}

function* DevelopersProfileSaga() {
  yield all([fork(watchGetDevelopersProfile)]);
}

export default DevelopersProfileSaga;
